module.exports = __webpack_public_path__ + "static/media/Hovhannes.c0b4ee1a.jpg";